import { FC } from 'react';
import compose from '../../../utils/components/_compose';
import injectTranslations from '../../../hocs/translation/injectTranslations';
import MainHeader, { MainHeaderProps, MainHeaderStatics } from './MainHeader';

import fr from './translations/fr';
import en from './translations/en';

export * from './MainHeader';

export default compose<FC<MainHeaderProps> & MainHeaderStatics>(
  injectTranslations('Core.MainHeader', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
)(MainHeader);
